import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import {AssayRunSchema} from 'results/assay-schemas/AssaySchemaConstants';
import * as Colors from 'ui-library/Colors';

import {AutomationInputFileConfigSpec, ClientAutomationOutputFileConfigSpec} from './RunSchemaSpecConstants';

export interface ConfigEditorProps<
  T extends AutomationInputFileConfigSpec | ClientAutomationOutputFileConfigSpec,
> {
  onUpdateConfig: (newConfig: T) => void;
  onValidationChange: (isValid: boolean) => void;
  onRemoveConfig: () => void;
  errors: Array<string>;
  index: number;
  isDuplicateName?: boolean;
  baseSchema: AssayRunSchema;
}

export interface AutomationInputFileConfigEditorProps
  extends ConfigEditorProps<AutomationInputFileConfigSpec> {
  inputFileConfig: AutomationInputFileConfigSpec;
  existingInputFileConfigs: Array<AutomationInputFileConfigSpec>;
}

export interface AutomationOutputFileConfigEditorProps
  extends ConfigEditorProps<ClientAutomationOutputFileConfigSpec> {
  outputFileConfig: ClientAutomationOutputFileConfigSpec;
  existingOutputFileConfigs: Array<ClientAutomationOutputFileConfigSpec>;
  ownerId: string;
  connectionSchemaId: string | null;
  shouldShowUploadedFilesOnly?: boolean;
}

export const SectionNumber = ({sectionNumber}: {sectionNumber: number}): JSX.Element => (
  <div className={css(automationFileConfigStyles.sectionNumber)}>{sectionNumber}</div>
);

export const automationFileConfigStyles = StyleSheet.create({
  columnTableContainer: {
    display: 'block',
  },
  description: {
    color: 'gray',
    fontWeight: 500,
    fontSize: '13px',
  },
  error: {
    color: 'red',
    fontWeight: 500,
    fontSize: '13px',
  },
  formatSectionContents: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-start',
  },
  formatSectionItem: {
    flex: 0.33,
    marginRight: '32px',
  },
  innerTitle: {
    color: Colors.NEAR_BLACK,
    fontSize: '13px',
    fontWeight: 600,
  },
  innerTitleContainer: {
    display: 'flex',
    alignItems: 'center',
  },
  nameTextBox: {
    width: 'calc(33% - 22px)',
  },
  sectionDescription: {
    marginBottom: '16px',
  },
  sectionDescriptionAbove: {
    marginTop: '16px',
  },
  sectionNumber: {
    position: 'absolute',
    zIndex: 30,
    top: '-3px',
    left: '-12px',
    float: 'left',
    backgroundColor: Colors.WHITE,
    color: Colors.GRAY_DARKER,
    border: `1px solid ${Colors.GRAY}`,
    borderRadius: '50%',
    boxShadow: `0 0 0 4px ${Colors.WHITE}`,
    width: '24px',
    height: '24px',
    textAlign: 'center',
    verticalAlign: 'center',
  },
  subsection: {
    position: 'relative',
    marginLeft: '24px',
    paddingLeft: '24px',
    paddingBottom: '24px',
  },
  subsectionBorder: {
    borderLeft: `1px solid ${Colors.GRAY_LIGHT}`,
  },
});
